import { render, staticRenderFns } from "./SoftSwissCurrencies.vue?vue&type=template&id=3cf3d529&"
import script from "./SoftSwissCurrencies.vue?vue&type=script&lang=js&"
export * from "./SoftSwissCurrencies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports